import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import {
  Box,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Autocomplete,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import { customTextColor } from "../../../utils/const";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { PiAddressBookLight } from "react-icons/pi";
import { IoIosAdd } from "react-icons/io";
import { PiUserLight } from "react-icons/pi";
import RequirementsJobList from "../../../components/common/RequirementsJobList";
import profile_image from "../../../assets/images/ajit_image.jpeg";
import { useFormik } from "formik";
import { IoIosArrowRoundBack } from "react-icons/io";
import * as Yup from "yup";
import {
  mode_of_interview,
  WORK_AUTHORIZATIONS,
  work_preference,
} from "../../../utils/const2";
import {
  createSubmissiontracker,
  getOneSubmissionTracker,
  getSubmissionTracker,
  updateSubmissiontracker,
} from "../../../redux/internal-tracking/InternalSubmissionSlice";
import { useDispatch, useSelector } from "react-redux";
import { allLocation } from "../../../redux/common/locationSlice";
import {
  addSkill,
  allSkill,
  resetAddedSkill,
} from "../../../redux/common/skillSlice";
import AddCandidateInRequirementDrawer from "./AddCandidateInRequirementDrawer";
import { FixedSizeList } from "react-window";
import AddCandidateListDrawer from "./AddCandidateListDrawer";
import AddCandidateDrawerResumeProfile from "./AddCandidateDrawerResumeProfile";
import { Icon } from "@iconify/react/dist/iconify.js";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const fieldStyles = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "5px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "25px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    // paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "25px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "20px",
};

const renderVirtualizedList = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...rest } = props;

  return (
    <div ref={ref} {...rest}>
      <FixedSizeList
        height={300} // Adjust dropdown height
        width="100%"
        itemSize={46} // Height of each item
        itemCount={children.length}
      >
        {({ index, style }) =>
          React.cloneElement(children[index], {
            style: { ...style, top: `${style.top}px` },
            onMouseDown: (event) => {
              // Prevent closing on click
              event.preventDefault();
            },
          })
        }
      </FixedSizeList>
    </div>
  );
});

const AddSubmisionDrawer = ({ handleClose, show, row, setIsEdit, isEdit }) => {
  const [viewData, setViewData] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [submisionRow, setSubmisionRow] = useState({});
  const [candidateListDetails, setCandidateListDetails] = useState({});
  const [showAddCandidate, setShow] = useState(false);
  const [showCandidate, setShowCandidate] = useState(false);
  const [inputText, setInputText] = useState("");
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseShowCandidate = () => setShowCandidate(false);
  const handleShowCandidate = () => setShowCandidate(true);

  const [showCandidateResume, setShowCandidateResume] = useState(false);
  const handleCloseShowCandidateResume = () => setShowCandidateResume(false);
  const handleShowCandidateResume = () => setShowCandidateResume(true);

  const locations = useSelector((state) => state.location);
  const internalSubStatus = useSelector(
    (state) => state.trackersubmission.status
  );
  const postData = useSelector((state) => state.trackersubmission.postData);
  const viewdata = useSelector((state) => state.trackersubmission.trackerData);
  const skillData = useSelector((state) => state.skill.data);
  const profile = useSelector((state) => state.profile.data);
  const addedSkill = useSelector((state) => state.skill.addedSkill);
  const workautho = useSelector((state) => state.workautho);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [data, setData] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalSubmissionDetails"))
  );

  const [dataview, setDataview] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalSubmissionDetailsWhichView"))
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      bdm_name: submisionRow?.bdm_name || null,
      // company_name: submisionRow?.company_name || null,
      job_title: submisionRow?.job_title || "",
      experience: submisionRow?.experience || null,
      location: submisionRow?.location || [],
      job_type: "full_Time",
      requirement_type: submisionRow?.requirement_type || [],
      rate: submisionRow?.rate || null,
      // bdm_mobile_no: submisionRow?.bdm_mobile_no || null,
      bdm_email: submisionRow?.bdm_email || null,
      mode_of_interview: submisionRow?.mode_of_interview || "",
      requirement_from: submisionRow?.requirement_from || null,
      client_name: submisionRow?.client_name || "",
      duration: submisionRow?.duration || null,
      job_description: submisionRow?.job_description || null,
      mandatory_skills: submisionRow?.mandatory_skills || null,
      no_of_opening: submisionRow?.no_of_opening || "",
      work_preference: submisionRow?.work_preference || "",
      work_authorization: submisionRow?.work_authorization || [],
    },
    validationSchema: Yup.object({
      job_title: Yup.string().required("Job Title is required"),
      experience: Yup.string().required("Experience is required"),
      location: Yup.array()
        .min(1, "Location is required")
        .required("Location is required"),
      requirement_type: Yup.array()
        .min(1, "Hirring Mode is required")
        .required("Hirring Mode is required"),

      // bdm_mobile_no: Yup.string()
      //   .matches(/^\d+$/, "Mobile Number must be digits only")
      //   .required("Mobile Number is required"),
      bdm_email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      mode_of_interview: Yup.string().required("Prefer Location is required"),
      job_description: Yup.string().required("Job Description is required"),
      work_preference: Yup.string().required("Work Preference is required"),
      no_of_opening: Yup.string().required("Number Of Opening is required"),
      work_authorization: Yup.array()
        .min(1, "Work Authorization is required")
        .required("Work Authorization is required"),
    }),
    onSubmit: (values) => {
      let id = submisionRow?.requirement_id;
      if (submisionRow !== undefined) {
        if (isEdit === false) {
          dispatch(createSubmissiontracker(values));
        } else {
          dispatch(updateSubmissiontracker({ values, id }));
        }
        // dispatch(updateSubmissiontracker({ values, id }));
      } else {
        let id = viewdata?.data?.requirement_id;
        if (dataview?.type !== "add") {
          dispatch(updateSubmissiontracker({ values, id }));
        } else {
          dispatch(createSubmissiontracker(values));
        }
      }
    },
  });

  useEffect(() => {
    dispatch(allSkill());
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  useEffect(() => {
    if (dataview?.type !== "add") {
      setViewData(viewdata?.requirements);
    }
  }, [viewdata, dataview]);

  // useEffect(() => {
  //   setSubmisionRow(submisionRow);
  //   let id = submisionRow?.requirement_id;
  //   dispatch(getOneSubmissionTracker(id));
  // }, [submisionRow, dispatch]);

  useEffect(() => {
    if (
      internalSubStatus === "update_submission_intenal_succeeded" ||
      internalSubStatus === "create_submission_intenal_succeeded"
    ) {
      if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
        handleShowCandidateResume();
      } else {
        handleShowCandidate();
      }
      setSubmisionRow(postData?.requirement);
    }
  }, [internalSubStatus, postData]);

  useEffect(() => {
    if (internalSubStatus === "add_candidate_to_submission") {
      let id = submisionRow?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
      dispatch(getSubmissionTracker());
      handleCloseShowCandidate();
      handleCloseShow();
      handleClose();
      formik.resetForm();
    }
  }, [internalSubStatus]);

  const handleFullNameChange = (event) => {
    const { value } = event.target;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      formik.setFieldValue("bdm_name", value);
    }
  };

  const handleMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) {
      formik.setFieldValue("bdm_mobile_no", value);
    }
  };

  const handleNoOfPosition = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 3) {
      formik.setFieldValue("no_of_opening", value);
    }
  };

  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set it to match content
    }
  };

  let prefer_tax_term;
  if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
    prefer_tax_term = [
      { id: "contract", name: "Contract" },
      { id: "contract_to_hire", name: "Contract To Hire" },
    ];
  } else {
    prefer_tax_term = [
      { id: "contract", name: "Contract" },
      { id: "contract_to_hire", name: "Contract To Hire" },
      { id: "full_Time", name: "Fulltime" },
      { id: "w2_with_benefit", name: "W2 Hourly Benefit" },
      { id: "w2_without_benefit", name: "W2 Hourly No Benefit" },
      { id: "1099", name: "1099" },
      { id: "working_in_all", name: "All" },
    ];
  }

  useEffect(() => {
    if (addedSkill?.location?.id) {
      const skillId = addedSkill?.location?.id;
      const currentSkills = formik.values.mandatory_skills || [];
      if (!currentSkills.includes(skillId)) {
        // Add the new skill to Formik's field
        formik.setFieldValue("mandatory_skills", [...currentSkills, skillId]);
        setInputText("");
        // ✅ Reset addedSkill in Redux to avoid re-triggering
        dispatch(resetAddedSkill());
      }
    }
  }, [addedSkill, formik, dispatch]);

  const handleAddSkill = useCallback(async () => {
    if (inputText.trim()) {
      const newSkill = inputText.trim();
      const isExistingSkill = skillData?.locations?.some(
        (skl) => skl.name.toLowerCase() === newSkill.toLowerCase()
      );

      if (!isExistingSkill) {
        await dispatch(addSkill({ name: newSkill })); // Add new skill
        dispatch(allSkill()); // Refresh mandatory_skills
      }
    }
  }, [inputText, skillData, dispatch]);

  const handleClearAll = () => {
    formik.setFieldValue("mandatory_skills", []); // Clear Formik field
    setInputText(""); // Clear input text

    dispatch(resetAddedSkill());
  };

  const handleOnClickCandidateAdd = (candidate) => {
    handleShow();
    setCandidateListDetails(candidate);
  };

  useEffect(() => {
    if (row) {
      setSubmisionRow(row);
    }
    formik.setFieldValue("mandatory_skills", row?.skills);
  }, [row]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "65%",
        backgroundColor: "#fafafa",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography>
          <b>Requirement Tracker</b>
        </Typography>
        <RxCross2
          style={{
            fontSize: "22px",
            with: "10%",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        <Box className={styles.add_structure} style={{ margin: "0" }}>
          <form onSubmit={formik.handleSubmit}>
            <Box
              className={styles.employer_details}
              sx={{
                backgroundColor: "#dae3f2",
                margin: "0 0 14px 0 !important",
                padding: "0 15px 15px !important",
              }}
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <PiUserLight
                      style={{ fontSize: "25px", color: "#3f475a" }}
                    />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Received from"
                    variant="standard"
                    type="text"
                    name="bdm_name"
                    onChange={handleFullNameChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bdm_name}
                    sx={fieldStyle}
                    disabled={isEdit !== false}
                  />
                </Grid>

                {/* <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <PiUserLight
                      style={{ fontSize: "25px", color: "#3f475a" }}
                    />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Company Name"
                    variant="standard"
                    type="text"
                    name="company_name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.company_name}
                    sx={fieldStyle}
                    disabled={isEdit !== false}
                  />
                  {formik.touched.company_name && formik.errors.company_name ? (
                    <div className={styles.error}>
                      {formik.errors.company_name}
                    </div>
                  ) : null}
                </Grid> */}
                {/* )} */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <PiMailboxLight
                      style={{ fontSize: "25px", color: "#3f475a" }}
                    />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Email ID"
                    variant="standard"
                    type="text"
                    name="bdm_email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bdm_email}
                    sx={fieldStyle}
                    disabled={isEdit !== false}
                  />
                  {formik.touched.bdm_email && formik.errors.bdm_email ? (
                    <div className={styles.error}>
                      {formik.errors.bdm_email}
                    </div>
                  ) : null}
                </Grid>

                {/* <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Phone No"
                    variant="standard"
                    type="number"
                    name="bdm_mobile_no"
                    onChange={handleMobileNoChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bdm_mobile_no}
                    sx={fieldStyle}
                    disabled={isEdit !== false}
                  />
                  {formik.touched.bdm_mobile_no &&
                  formik.errors.bdm_mobile_no ? (
                    <div className={styles.error}>
                      {formik.errors.bdm_mobile_no}
                    </div>
                  ) : null}
                </Grid> */}
              </Grid>
            </Box>

            <Grid container className={styles.candidate_field_section}>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiChairLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="ph:desktop-tower-light" height={25} width={25} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Job Title"
                  variant="standard"
                  name="job_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.job_title}
                  sx={fieldStyle}
                  disabled={isEdit !== false}
                />
                {formik.touched.job_title && formik.errors.job_title ? (
                  <div className={styles.error}>{formik.errors.job_title}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiAddressBookLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="ion:calendar-outline" height={25} width={25} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Experience Required"
                  variant="standard"
                  type="text"
                  disabled={isEdit !== false}
                  onChange={(e) => {
                    let rawValue = e.target.value.replace(/[^0-9]/g, ""); // Only digits
                    if (rawValue.length > 2) {
                      rawValue = rawValue.slice(0, 2); // Limit to 2 digits
                    }
                    formik.setFieldValue("experience", rawValue);
                  }}
                  name="experience"
                  // onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={
                    formik.values.experience
                      ? `${formik.values.experience} ${
                          formik.values.experience > 1 ? "Years" : "Year"
                        }`
                      : ""
                  }
                  // value={formik.values.experience}
                  sx={fieldStyle}
                />
                {formik.touched.experience && formik.errors.experience ? (
                  <div className={styles.error}>{formik.errors.experience}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="ph:map-pin-simple-line" height={25} width={25} />
                </Box>
                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={locations?.data?.locations || []}
                  disableCloseOnSelect
                  value={
                    locations?.data?.locations?.filter((location) =>
                      formik.values.location?.includes(location.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedLocations = value?.map(
                      (location) => location?.id
                    );
                    formik.setFieldValue("location", selectedLocations);
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>{" "}
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location"
                      variant="standard"
                      size="small"
                      // placeholder="Prefer Location"
                      name="location"
                      sx={fieldStyle}
                      disabled={isEdit !== false}
                      InputLabelProps={{
                        sx: { marginLeft: "2px" },
                      }}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />
                {formik.touched.location && formik.errors.location ? (
                  <div className={styles.error}>{formik.errors.location}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiAddressBookLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="si:fact-check-line" height={25} width={25} />
                </Box>

                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={prefer_tax_term || []}
                  disableCloseOnSelect
                  value={
                    prefer_tax_term?.filter((tax_term) =>
                      formik.values.requirement_type?.includes(tax_term.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedPrefertaxterm = value?.map(
                      (tax_term) => tax_term?.id
                    );
                    formik.setFieldValue(
                      "requirement_type",
                      selectedPrefertaxterm
                    );
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>{" "}
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Mode of Hiring"
                      variant="standard"
                      size="small"
                      name="requirement_type"
                      disabled={isEdit !== false}
                      sx={fieldStyle}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />

                {formik.touched.requirement_type &&
                formik.errors.requirement_type ? (
                  <div className={styles.error}>
                    {formik.errors.requirement_type}
                  </div>
                ) : null}
              </Grid>
              {/* {formik.values.requirement_type?.includes("full_Time") &&
              formik.values.requirement_type?.length > 1 ? null : (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
              
                    <Icon icon="bi:hourglass-top" height={25} width={25} />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Duration"
                    variant="standard"
                    type="text"
                    name="duration"
                    disabled={isEdit !== false}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                      formik.setFieldValue("duration", rawValue);
                    }}
                    onBlur={formik.handleBlur}
                    value={
                      formik.values.duration
                        ? `${formik.values.duration} Month`
                        : ""
                    }
                    sx={fieldStyle}
                  />
                </Grid>
              )} */}

              {formik.values.requirement_type?.includes("full_Time") ? (
                ""
              ) : (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    {/* <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} /> */}
                    <Icon icon="bi:hourglass-top" height={25} width={25} />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Duration"
                    variant="standard"
                    type="text"
                    name="duration"
                    disabled={isEdit !== false}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                      formik.setFieldValue("duration", rawValue);
                    }}
                    onBlur={formik.handleBlur}
                    value={
                      formik.values.duration
                        ? `${formik.values.duration} Month`
                        : ""
                    }
                    sx={fieldStyle}
                  />
                </Grid>
              )}

              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiAddressBookLight style={{ fontSize: "25px" }} /> */}
                  <Icon
                    icon="ph:identification-card-light"
                    height={25}
                    width={25}
                  />
                </Box>
                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={workautho?.data?.work_authorization_data || []}
                  disableCloseOnSelect
                  value={
                    workautho?.data?.work_authorization_data?.filter(
                      (tax_term) =>
                        formik.values.work_authorization?.includes(tax_term.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedPrefertaxterm = value?.map(
                      (tax_term) => tax_term?.id
                    );
                    formik.setFieldValue(
                      "work_authorization",
                      selectedPrefertaxterm
                    );
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>{" "}
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Work Authorization"
                      variant="standard"
                      size="small"
                      name="work_authorization"
                      disabled={isEdit !== false}
                      sx={fieldStyle}
                      InputLabelProps={{
                        sx: { marginLeft: "2px" },
                      }}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />

                {formik.touched.work_authorization &&
                formik.errors.work_authorization ? (
                  <div className={styles.error}>
                    {formik.errors.work_authorization}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiAddressBookLight style={{ fontSize: "25px" }} /> */}
                  <Icon
                    icon="hugeicons:computer-desk-02"
                    height={25}
                    width={25}
                  />
                </Box>
                <TextField
                  select
                  variant="standard"
                  label="Work Preference"
                  name="work_preference"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.work_preference}
                  disabled={isEdit !== false}
                  sx={fieldStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                >
                  {work_preference.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.work_preference &&
                formik.errors.work_preference ? (
                  <div className={styles.error}>
                    {formik.errors.work_preference}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} /> */}
                  <Icon
                    icon="fluent:video-person-16-filled"
                    height={25}
                    width={25}
                  />
                </Box>
                <TextField
                  select
                  label="Mode of Interview"
                  variant="standard"
                  name="mode_of_interview"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.mode_of_interview}
                  sx={fieldStyle}
                  disabled={isEdit !== false}
                >
                  {mode_of_interview.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.mode_of_interview &&
                formik.errors.mode_of_interview ? (
                  <div className={styles.error}>
                    {formik.errors.mode_of_interview}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} /> */}
                  <Icon
                    icon="hugeicons:save-money-dollar"
                    height={25}
                    width={25}
                  />
                </Box>
                <TextField
                  label={
                    formik.values.requirement_type?.includes("full_Time")
                      ? "Salary (Optional)"
                      : "Rate (Optional)"
                  }
                  variant="standard"
                  name="rate"
                  type="text"
                  disabled={isEdit !== false}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Keep only numeric input

                    if (rawValue.length <= 3) {
                      formik.setFieldValue("rate", rawValue); // Set value only if length <= 3
                    }
                  }}
                  onBlur={formik.handleBlur}
                  onFocus={() => setIsFocused(true)}
                  value={
                    formik.values.rate
                      ? `$${formik.values.rate} ${
                          formik.values.requirement_type?.includes("full_Time")
                            ? "Yearly"
                            : "Hourly"
                        }`
                      : ""
                  }
                  sx={fieldStyle}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="ph:building-office" height={25} width={25} />
                </Box>
                <TextField
                  label="Client Name (Optional)"
                  variant="standard"
                  name="client_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.client_name}
                  sx={fieldStyle}
                  disabled={isEdit !== false}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiAddressBookLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  label="No of Position Opening"
                  variant="standard"
                  name="no_of_opening"
                  type="number"
                  onChange={handleNoOfPosition}
                  onBlur={formik.handleBlur}
                  value={formik.values.no_of_opening}
                  sx={fieldStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                />
                {formik.touched.no_of_opening && formik.errors.no_of_opening ? (
                  <div className={styles.error}>
                    {formik.errors.no_of_opening}
                  </div>
                ) : null}
              </Grid>
            </Grid>

            <Box className={styles.mandatory_description}>
              <Box sx={{ color: customTextColor }}>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="7"
                  placeholder="Job description"
                  name="job_description"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.job_description}
                  onInput={(event) => autoResize(event.target)}
                  ref={(el) => el && autoResize(el)}
                  style={{ overflow: "hidden", resize: "none", border: "none" }}
                  disabled={isEdit !== false}
                ></textarea>

                <hr style={{ marginBottom: "0" }}></hr>
                {/* <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="4"
              placeholder="Mandatory Skills"
              name="mandatory_skills"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.mandatory_skills}
              onInput={(event) => autoResize(event.target)}
              ref={(el) => el && autoResize(el)}
              style={{ overflow: "hidden", resize: "none", border: "none" }}
            ></textarea> */}
              </Box>
              {formik.touched.job_description &&
              formik.errors.job_description ? (
                <div className={styles.error} style={{ border: "none" }}>
                  {formik.errors.job_description}
                </div>
              ) : null}
            </Box>

            <Box>
              {/* <Autocomplete
            multiple
            id="autocomplete-multi-select"
            options={skillData?.locations || []}
            disableCloseOnSelect
            value={
              skillData?.locations?.filter((skl) =>
                formik.values.mandatory_skills?.includes(skl.id)
              ) || []
            }
            onChange={(event, value) => {
              const selectedLocations = value?.map((skl) => skl?.id);
              formik.setFieldValue("mandatory_skills", selectedLocations);
            }}
            onBlur={formik.handleBlur}
            getOptionLabel={(option) => option?.name || ""}
            renderOption={(props, option, { selected }) => (
              <MenuItem {...props}>
                <Checkbox
                  checked={selected}
                  sx={{ marginRight: 0, marginLeft: 0 }}
                />
                <span>{option?.name}</span>{" "}
              </MenuItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Mandatory Skills (Optional)"
                variant="standard"
                size="small"
                name="mandatory_skills"
                sx={fieldStyles}
                disabled={isEdit !== false}
              />
            )}
            sx={{ backgroundColor: "#fff", width: "100%" }}
          /> */}

              <Autocomplete
                multiple
                id="autocomplete-multi-select"
                options={skillData?.locations || []}
                disableCloseOnSelect
                value={
                  skillData?.locations?.filter((skl) =>
                    formik.values.mandatory_skills?.includes(skl.id)
                  ) || []
                }
                onChange={(event, value) => {
                  const selectedLocations = value?.map((skl) => skl?.id);
                  formik.setFieldValue("mandatory_skills", selectedLocations);

                  // ✅ Reset addedSkill when manually removing mandatory_skills
                  if (selectedLocations.length === 0) {
                    handleClearAll(); // Call clear all method
                  } else {
                    dispatch(resetAddedSkill());
                  }
                }}
                onBlur={formik.handleBlur}
                getOptionLabel={(option) => option?.name || ""}
                inputValue={inputText}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setInputText(newInputValue);
                  }
                }}
                renderOption={(props, option, { selected }) => (
                  <MenuItem {...props}>
                    <Checkbox
                      checked={selected}
                      sx={{ marginRight: 0, marginLeft: 0 }}
                    />
                    <span>{option?.name}</span>
                  </MenuItem>
                )}
                ListboxComponent={renderVirtualizedList} // Use virtualized list
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Mandatory Skills"
                    variant="standard"
                    size="small"
                    name="mandatory_skills"
                    disabled={isEdit !== false}
                    sx={fieldStyles}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleAddSkill();
                      }
                    }}
                  />
                )}
                sx={{ backgroundColor: "#fff", width: "100%" }}
              />
            </Box>

            <Box className={styles.requiter_profile_section}>
              {viewData?.submissions_for_requirement?.length > 111 &&
                viewData?.submissions_for_requirement?.map((res) => {
                  return (
                    <RequirementsJobList
                      image={profile_image}
                      name={res?.full_name}
                      skill={viewData?.job_title}
                      phoneno={res?.mobile_no}
                      email={res?.email}
                      btn1="Update"
                      btn2="View Details"
                      res={res}
                      row={submisionRow}
                      type="add"
                    />
                  );
                })}
            </Box>
            <Box className={styles.add_candidate_btns}>
              <Box className={styles.add_back_btns}>
                <button
                  onClick={() => {
                    navigate("/submision-tracker");
                    localStorage.setItem(
                      "internalSubmissionDetails",
                      JSON.stringify({ type: "add" })
                    );
                  }}
                  style={{
                    border: "1.5px solid #4287f5",
                    marginRight: "10px",
                    padding: "4.5px 10px ",
                  }}
                  disabled={internalSubStatus === "loading"}
                >
                  <IoIosArrowRoundBack
                    style={{ fontSize: "25px", color: "#4287f5" }}
                  />
                </button>
              </Box>
              <button
                onClick={formik.handleSubmit}
                style={
                  internalSubStatus === "loading"
                    ? { padding: "5.5px 60px", backgroundColor: "#3856a6" }
                    : {
                        backgroundColor: "#3856a6",
                        padding: "5.5px 5px 5.5px 10px",
                      }
                }
              >
                {internalSubStatus === "loading" ? (
                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                ) : (
                  "Add Submission"
                )}
                {internalSubStatus !== "loading" && (
                  <IoIosAdd style={{ fontSize: "25px", marginLeft: "5px" }} />
                )}
              </button>
            </Box>
          </form>
          <AddCandidateInRequirementDrawer
            handleShow={handleShow}
            handleClose={handleCloseShow}
            show={showAddCandidate}
            row={submisionRow}
            setDataview={setDataview}
            setData={setData}
            candidateListDetails={candidateListDetails}
            setIsEdit={setIsEdit}
          />

          <AddCandidateListDrawer
            handleShow={handleShowCandidate}
            handleClose={handleCloseShowCandidate}
            show={showCandidate}
            row={submisionRow}
            handleShowAdd={handleOnClickCandidateAdd}
            setIsEdit={setIsEdit}
          />

          <AddCandidateDrawerResumeProfile
            handleShow={handleShowCandidateResume}
            handleClose={handleCloseShowCandidateResume}
            show={showCandidateResume}
            row={submisionRow}
            handleShowAdd={handleOnClickCandidateAdd}
          />
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddSubmisionDrawer;
